import api from "./axios";

export const applyPromo = async (code: string) => {
  return await api.post("/api/web-api/promo/add", {
    code: code,
  });
};
